import script from "./CuButton.vue?vue&type=script&setup=true&lang=js"
export * from "./CuButton.vue?vue&type=script&setup=true&lang=js"

import "./CuButton.vue?vue&type=style&index=0&id=48052a08&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48052a08"]])

export default __exports__